import React from "react";
import Icon from "components/AppIcon";

const marketData = {
  indices: [
    { name: "S&P 500", value: "5,842.31", change: "+0.74%", points: "+42.87", up: true },
    { name: "NASDAQ", value: "18,234.56", change: "+1.12%", points: "+201.43", up: true },
    { name: "DOW JONES", value: "43,891.22", change: "-0.18%", points: "-79.34", up: false },
    { name: "RUSSELL 2000", value: "2,187.45", change: "+0.53%", points: "+11.52", up: true },
  ],
  topMovers: [
    { ticker: "NVDA", name: "NVIDIA Corp", change: "+4.82%", up: true },
    { ticker: "AAPL", name: "Apple Inc", change: "+2.14%", up: true },
    { ticker: "TSLA", name: "Tesla Inc", change: "-3.21%", up: false },
    { ticker: "AMZN", name: "Amazon", change: "+1.87%", up: true },
  ],
  trendingSectors: [
    { name: "Technology", change: "+2.3%", up: true, icon: "Cpu" },
    { name: "Healthcare", change: "+1.1%", up: true, icon: "Heart" },
    { name: "Energy", change: "-0.8%", up: false, icon: "Zap" },
    { name: "Finance", change: "+0.6%", up: true, icon: "DollarSign" },
  ],
};

export default function MarketSnapshot() {
  return (
    <section aria-label="Market Snapshot">
      <div className="flex items-center justify-between mb-3 md:mb-4">
        <h2 className="font-heading font-semibold text-lg md:text-xl lg:text-2xl" style={{ color: "var(--color-foreground)" }}>
          Market Snapshot
        </h2>
        <span className="font-caption text-xs md:text-sm" style={{ color: "var(--color-muted-foreground)" }}>
          Mar 07, 2026 · Live
        </span>
      </div>
      {/* Indices */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3 mb-3 md:mb-4">
        {marketData?.indices?.map((idx) => (
          <div
            key={idx?.name}
            className="rounded-lg p-3 md:p-4"
            style={{ background: "var(--color-primary)", border: "1px solid rgba(133,113,77,0.2)" }}
          >
            <p className="font-caption text-xs font-medium mb-1" style={{ color: "rgba(255,255,255,0.6)" }}>
              {idx?.name}
            </p>
            <p className="font-data font-semibold text-sm md:text-base text-white whitespace-nowrap">
              {idx?.value}
            </p>
            <div className="flex items-center gap-1 mt-1">
              <Icon
                name={idx?.up ? "TrendingUp" : "TrendingDown"}
                size={12}
                color={idx?.up ? "#22c55e" : "#ef4444"}
              />
              <span
                className="font-data text-xs font-medium"
                style={{ color: idx?.up ? "#22c55e" : "#ef4444" }}
              >
                {idx?.change}
              </span>
            </div>
          </div>
        ))}
      </div>
      {/* Top Movers & Trending Sectors */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
        {/* Top Movers */}
        <div
          className="rounded-lg p-3 md:p-4"
          style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}
        >
          <h3 className="font-caption font-semibold text-sm mb-3" style={{ color: "var(--color-foreground)" }}>
            Top Movers
          </h3>
          <div className="space-y-2">
            {marketData?.topMovers?.map((m) => (
              <div key={m?.ticker} className="flex items-center justify-between">
                <div className="flex items-center gap-2 min-w-0">
                  <span
                    className="font-data font-semibold text-xs px-2 py-0.5 rounded flex-shrink-0"
                    style={{ background: "rgba(0,48,87,0.08)", color: "var(--color-primary)" }}
                  >
                    {m?.ticker}
                  </span>
                  <span className="font-caption text-xs truncate" style={{ color: "var(--color-muted-foreground)" }}>
                    {m?.name}
                  </span>
                </div>
                <span
                  className="font-data text-xs font-semibold whitespace-nowrap ml-2"
                  style={{ color: m?.up ? "#059669" : "#DC2626" }}
                >
                  {m?.change}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Trending Sectors */}
        <div
          className="rounded-lg p-3 md:p-4"
          style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}
        >
          <h3 className="font-caption font-semibold text-sm mb-3" style={{ color: "var(--color-foreground)" }}>
            Trending Sectors
          </h3>
          <div className="space-y-2">
            {marketData?.trendingSectors?.map((s) => (
              <div key={s?.name} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div
                    className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0"
                    style={{ background: "rgba(133,113,77,0.12)" }}
                  >
                    <Icon name={s?.icon} size={13} color="var(--color-accent)" />
                  </div>
                  <span className="font-caption text-xs" style={{ color: "var(--color-foreground)" }}>
                    {s?.name}
                  </span>
                </div>
                <span
                  className="font-data text-xs font-semibold"
                  style={{ color: s?.up ? "#059669" : "#DC2626" }}
                >
                  {s?.change}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}